import script from "./change-siddars.vue?vue&type=script&setup=true&lang=ts"
export * from "./change-siddars.vue?vue&type=script&setup=true&lang=ts"

import "./change-siddars.vue?vue&type=style&index=0&id=6e0ab016&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e0ab016"]])

export default __exports__